export default __webpack_public_path__ + "static/media/Megosu - Moooi.a6dd6f16.jpg";